export default {
  noDataDescription: 'Nenašli sa žiadne dáta pre vybrané snímače a časové rozsahy',
};
